import { ValidationError } from 'core-lib';

export class AdminDetailsViewModel {
    constructor() {
    }

    public isLoading: boolean;
    public isOpening: boolean;

    public userId: number;
    public userName: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public role: number;
    public password: string;
    public confirmPassword: string;
    
    public newPassword: string;

    public isActive: boolean;
    public isNew: boolean;

    public errors: ValidationError[];

    public header: string;
    public permitId: string;
    public permitNo: string;
    public businessName: string;
}
